import Price from 'src/components/ui/Price'
import { useFormattedUSDPrice } from 'src/sdk/product/useFormattedPrice'

import { PRICE_TYPES } from '../../../constants'

export const ProductMKTPrice = ({
  priceValue,
  priceType,
  componentToRender,
}: {
  priceValue: number
  priceType: string
  componentToRender: string
}) => {
  if (componentToRender === 'productDetails') {
    return (
      <Price
        value={priceValue}
        formatter={useFormattedUSDPrice}
        testId={priceType === PRICE_TYPES.listPrice ? 'list-price' : 'price'}
        data-value={priceValue}
        variant={priceType === PRICE_TYPES.listPrice ? 'listing' : 'spot'}
        classes={
          priceType === PRICE_TYPES.listPrice ? 'text__legend' : 'text__lead'
        }
        SRText={
          priceType === PRICE_TYPES.listPrice
            ? 'Original price:'
            : 'Sale Price:'
        }
      />
    )
  }

  if (componentToRender === 'suggestionProductCard') {
    return (
      <Price
        value={priceValue}
        formatter={useFormattedUSDPrice}
        testId="price"
        data-value={priceValue}
        variant="spot"
        classes="text__title-mini"
        SRText="Price:"
      />
    )
  }

  if (componentToRender === 'shelfProductCard') {
    return (
      <Price
        value={priceValue}
        formatter={useFormattedUSDPrice}
        testId={priceType === PRICE_TYPES.listPrice ? 'list-price' : 'price'}
        data-value={priceValue}
        variant={priceType === PRICE_TYPES.listPrice ? 'listing' : 'spot'}
        classes={
          priceType === PRICE_TYPES.listPrice ? 'text__legend' : 'text__body'
        }
        SRText={
          priceType === PRICE_TYPES.listPrice
            ? 'Original price:'
            : 'Sale Price:'
        }
      />
    )
  }

  return <></>
}
